module.exports = __webpack_public_path__ + "front/img/10_3.8b40999f.png";